import { useQuery } from "@tanstack/react-query";
import axios from "../axios";

const useGetTransitions = () => {
  return useQuery({
    queryKey: ["transactions"],
    queryFn: async () => {
        try {
          const response = await axios.get("/api/transaction");
          return response.data;
        } catch (error) {
          throw error;
        }
      },
    staleTime: 30000, // Optional
  });
};

export default useGetTransitions;
